// @lumi/app-kit shared i18n vocabulary (ADR 0026 §7) — locale fr.
// Byte-identical common.*/errors.* used across >=3 apps + owned by app-kit components.
// Apps merge appKitMessages under their own catalog; the no-shadow check forbids an
// app from redefining these keys. Generated from the per-app catalogs.
export default {
  // The sidebar's account menu + history buttons (suite design foundation, spec §4):
  // byte-identical across every chrome, so owned here rather than by nine app catalogs.
  accountMenu: {
    profile: 'Mon profil',
    settings: 'Paramètres',
    theme: 'Apparence',
    themeLight: 'Clair',
    themeDark: 'Sombre',
    support: 'Assistance',
    back: 'Retour',
    forward: 'Suivant',
    collapseSidebar: 'Réduire la barre latérale',
    expandSidebar: 'Développer la barre latérale',
    // The account row of a phone-only account (issue 698): no name, no address.
    signedIn: 'Connecté',
  },
  // A sidebar entry another of the viewer's own roles opens (#1028): the
  // greyed entry's hint, its switch dialog, and the role list joiner.
  roleLock: {
    hint: 'Uniquement en tant que {roles}. Changer de rôle : en bas à gauche, votre compte → Rôle.',
    body: 'Vous avez accès à cet espace en tant que {roles}. Vous travaillez actuellement en tant que {active}.',
    action: 'Ouvrir en tant que {role}',
    where: 'Vous pouvez changer de rôle à tout moment : en bas à gauche, votre compte → Rôle.',
    listOr: '{list} ou {last}',
  },
  common: {
    // Every DateField's calendar and typing hint (issue 823; People's own until then).
    datePicker: {
      open: 'Ouvrir le calendrier',
      previousMonth: 'Mois précédent',
      nextMonth: 'Mois suivant',
      month: 'Mois',
      year: 'Année',
      clear: 'Effacer la date',
      dayToken: 'JJ',
      monthToken: 'MM',
      yearToken: 'AAAA',
    },
    deactivate: 'Désactiver',
    revoke: 'Révoquer',
    remove: 'Retirer',
    actions: 'Actions',
    calendar: 'Calendrier',
    cancel: 'Annuler',
    close: 'Fermer',
    confirmTitle: 'Confirmer',
    contactSupport: 'Contacter le support',
    copyLink: 'Copier le lien',
    edit: 'Modifier',
    language: 'Langue',
    linkCopied: 'Lien copié',
    linkCopyFailed: 'Impossible de copier le lien',
    moduleListHeading: 'Vos modules',
    moduleTeaserAction: 'Ajouter dans la facturation',
    moduleTeaserHeading: 'Également dans lumi',
    moduleTeaserNote: 'Le propriétaire de l’espace de travail, les administrateurs et les Billing Managers peuvent ajouter ces modules.',
    moduleTeaserTag: 'Hors de votre forfait',
    no: 'Non',
    nothingHere: 'Rien ici pour le moment',
    ok: 'OK',
    refresh: 'Actualiser',
    retry: 'Réessayer',
    role: 'Rôle',
    save: 'Enregistrer',
    search: 'Rechercher',
    switchModule: 'Changer de module',
    tabsNext: 'Afficher les onglets suivants',
    tabsPrevious: 'Afficher les onglets précédents',
    understood: 'Compris',
    userDeactivated: '{name} (compte désactivé)',
    yes: 'Oui',
  },
  errors: {
    // ADR 0036 code-first branch (errorKeyFor): a backend `code` wins over the
    // status. `invalid_credentials` is what every login door answers a bad
    // sign-in with — a bare 401 would otherwise fall through to
    // `errors.unauthorized`, telling someone who mistyped their password that
    // their session expired (issue 364, F10). It never lets a caller tell an
    // unknown account apart from a mistyped password — the two answer
    // identically — so the copy names both fields.
    // `MASTER_INVITE_REJECTED` is people-api's fallback when the identity
    // service refuses an invitation payload without a code of its own (issue
    // 364, decisions round 1): without an entry here it degrades to the
    // status-derived message, which says nothing about what to look at. Its
    // sibling `MASTER_TENANT_NOT_FOUND` stays local to PersonDetailView on
    // purpose — that one names a next step specific to that screen.
    codes: {
      invalid_credentials: 'Échec de la connexion. Veuillez vérifier votre adresse e-mail et votre mot de passe.',
      MASTER_INVITE_REJECTED: 'Cette invitation a été refusée car les informations de la personne n’ont pas pu être acceptées. Veuillez vérifier l’adresse e-mail et le nom dans la fiche de la personne, puis réessayer.',
      PERSON_EMAIL_INVALID: 'Aucune adresse e-mail valide n’est associée à cette personne, un identifiant ne peut donc pas être invité. Veuillez d’abord corriger l’adresse dans la fiche de la personne.',
      PERSON_PHONE_INVALID: 'Ce numéro de mobile n’est pas valide. Saisissez-le au format international, avec + et l’indicatif du pays, p. ex. +33 6 12 34 56 78.',
      PERSON_ACCESS_PHONE_TAKEN: 'Une autre personne a déjà un accès avec ce numéro de mobile, ou en reçoit un. Un numéro, une personne.',
      PHONE_ACCESS_UNAVAILABLE: 'L’accès par numéro de mobile n’est pas disponible ici — pour cet espace de travail ou pour le pays de ce numéro. Utilisez plutôt une adresse e-mail.',
      SUITE_ROLE_NEEDS_EMAIL: 'Cette personne se connecte avec un numéro de mobile et n’a pas d’adresse e-mail. Les rôles de suite reçoivent des e-mails juridiques, de facturation et de consentement : ils exigent une adresse.',
      OWNER_NEEDS_EMAIL: 'Cette personne se connecte avec un numéro de mobile et n’a pas d’adresse e-mail. Le propriétaire reçoit des e-mails juridiques et contractuels : la propriété exige une adresse.',
      RECORD_CHANGED: 'Quelqu’un d’autre a modifié cet enregistrement pendant que vous le modifiiez. Rechargez-le : votre saisie est conservée comme brouillon.',
    },
    appUpdatedBody: 'Cette page n’a pas pu se charger entièrement car l’application a été mise à jour. Rechargez pour continuer.',
    appUpdatedTitle: 'Une nouvelle version est disponible',
    conflict: 'Cette action est en conflit avec l’état actuel. Rechargez puis réessayez.',
    contactSupport: 'Contacter le support',
    exhausted: 'Cela semble vraiment cassé. Nous sommes désolés. Veuillez contacter le support.',
    failedTitle: 'Échec de l’action',
    forbidden: 'Vous n’avez pas l’autorisation pour cette action.',
    loadFailedTitle: 'Chargement impossible',
    network: 'Pas de connexion au serveur. Vérifiez votre connexion Internet.',
    notFound: 'L’élément demandé est introuvable.',
    rateLimited: 'Trop de requêtes. Patientez un instant puis réessayez.',
    recordChangedReload: 'Quelqu’un d’autre a enregistré cet élément après que vous l’avez ouvert : votre modification n’a donc pas été appliquée. Rechargez pour voir la version actuelle ; votre saisie est conservée et peut être restaurée.',
    refreshFailedTitle: 'Ces données ne sont peut-être plus à jour',
    server: 'Une erreur serveur est survenue. Réessayez plus tard.',
    timeout: 'Le serveur n’a pas répondu à temps. Réessayez dans un instant.',
    unauthorized: 'Votre session a expiré. Veuillez vous reconnecter.',
    unexpected: "Une erreur s'est produite lors de l'affichage. Veuillez réessayer.",
    validation: 'Veuillez vérifier votre saisie.',
  },
  notReady: {
    title: 'Ce n’est pas encore prêt pour vous',
    body: 'Votre espace de travail est encore en préparation. Nous vous ramènerons au workspace dans 5 secondes.',
  },
  // The workspace this app was opened on does not exist, or can no longer be
  // reached (issue 364, F57). ONE message for BOTH causes on purpose: ats-api
  // answers a suspended tenant and an unknown slug identically, and splitting
  // the copy would confirm which workspaces exist. `body` therefore names no
  // cause, and nothing on the page names a workspace, a slug or a person.
  tenantUnavailable: {
    title: 'Cet espace de travail n’est pas accessible',
    body: 'Cet espace de travail n’existe pas ou n’est pas accessible pour le moment — veuillez vérifier l’adresse que vous avez ouverte.',
    accountLead: 'Vos propres données et vos factures restent accessibles depuis votre compte lumi.',
    accountCta: 'Accéder à votre compte lumi',
    supportLead: 'S’il s’agit d’une erreur, contactez-nous et nous réglerons cela avec vous.',
    // The signed-in person's own membership is gone (issue 669): a revoked demo guest,
    // or a demo that ended under an open tab.
    ended: {
      title: 'Vous n’avez pas accès à cet espace de travail',
      body: 'Vous êtes connecté, mais vous n’êtes pas (ou plus) membre de cet espace de travail. Si vous étiez invité à une démo, la démo est terminée ou votre invitation a été retirée.',
      accountLead: 'Votre propre compte lumi n’est pas concerné.',
    },
  },
  billing: {
    banner: {
      suspendedTitle: 'Espace verrouillé',
      suspendedMessage: 'Cet espace de travail est suspendu. Veuillez nous contacter pour rétablir l’accès.',
      lockedBody: 'Cet espace de travail a été verrouillé en raison d’un problème de facturation en suspens. L’accès à tous les modules est actuellement suspendu.',
      lockedSupportLead: 'Pour rétablir l’accès, contactez notre équipe d’assistance :',
      lockedSupportCta: 'Contacter l’assistance',
      lockoutOn: 'Sinon, il sera verrouillé le {date}.',
      fixCardTitle: 'Mettez à jour votre carte',
      fixCardBody: 'Votre dernier paiement a été refusé car votre carte n’a pas été acceptée.',
      fixCardCta: 'Mettre à jour la carte',
      softDeclineTitle: 'Assurez votre paiement',
      softDeclineBody: 'Nous n’avons pas pu encaisser votre dernier paiement et réessaierons automatiquement. Assurez-vous que votre moyen de paiement est suffisamment approvisionné.',
      softDeclineCta: 'Vérifier le moyen de paiement',
      scaTitle: 'Confirmez votre paiement',
      scaBody: 'Votre banque doit confirmer ce paiement avant que nous puissions l’encaisser.',
      scaCta: 'Confirmer le paiement',
      recoveryError: 'Le paiement n’a pas pu être lancé pour le moment. Veuillez réessayer dans un instant.',
      chargebackTitle: 'Réglez votre paiement annulé',
      chargebackBody: 'Votre banque a annulé un paiement, il est donc de nouveau dû. Ajoutez un moyen de paiement pour le régler.',
      chargebackCta: 'Ajouter un moyen de paiement',
      trialTitle: 'Ajoutez un moyen de paiement',
      trialBody: 'Votre essai est terminé. Ajoutez un moyen de paiement pour garder cet espace de travail actif.',
      trialCta: 'Ajouter un moyen de paiement',
      reviewTitle: 'Vérifiez votre facturation',
      reviewBody: 'Cet espace de travail nécessite une action de facturation pour rester actif.',
      reviewCta: 'Gérer la facturation',
      contactTitle: 'Contactez votre administrateur',
      contactBody: 'Un problème de facturation doit être traité pour garder cet espace de travail actif.',
    },
  },
  legalNoticeBanner: {
    title: 'Les mentions légales ont besoin de votre attention',
    employeeBody: 'Les invitations sont suspendues tant que l’avis de confidentialité pour les salariés n’est pas complet.',
    candidateBody: 'Le portail carrière est hors ligne tant que les mentions pour les candidats ne sont pas complètes.',
    imprintBody: 'Le portail carrière est hors ligne tant que des mentions légales ne sont pas enregistrées.',
    candidateImprintBody: 'Le portail carrière est hors ligne tant que les mentions pour les candidats ne sont pas complètes et que des mentions légales ne sont pas enregistrées.',
    cta: 'Ouvrir Mentions légales',
  },
  // The one "needs you" strip (issue 713): the list label, the hide control and the
  // per-item sentences. A lone legal item reuses legalNoticeBanner.* word for word.
  needsYou: {
    label: 'Il vous reste à faire :',
    hide: 'Masquer',
    timeRules: {
      link: 'Règles de temps de travail',
      cta: 'Vérifier',
      body: 'Les règles de temps de travail n’ont pas encore été vérifiées. lumi calcule avec les règles légales par défaut et se contente d’avertir jusqu’à ce que quelqu’un confirme qu’elles conviennent à votre entreprise.',
    },
    legal: { link: 'Compléter les mentions légales' },
    billing: {
      link: 'Compléter la facturation',
      cta: 'Ouvrir la facturation',
      bodyBoth: 'Renseignez vos données de facturation et un moyen de paiement pour que votre espace de travail continue de fonctionner sans interruption.',
      bodyInvoiceDetails: 'Renseignez vos données de facturation pour que vos factures soient émises correctement.',
      bodyPaymentMethod: 'Ajoutez un moyen de paiement pour que votre espace de travail continue de fonctionner sans interruption.',
    },
  },
  // Consented temporary support access (ADR 0041): the marker every module
  // chrome shows beside the tenant name while a supporter is inside a grant.
  supportAccess: {
    label: 'Accès support',
    until: 'Accès support temporaire jusqu’au {until} — tout ce que vous faites ici est consigné dans le journal d’audit de ce tenant.',
  },
  // Idle session timeout (issue 265). Owned by app-kit's IdleLogoutGuard, except
  // idleSignedOut — the login pages (workspace, system-admin) render that after
  // the bounce, and it is the same suite-wide policy statement, so it stays in one
  // place rather than drifting between the two login surfaces.
  session: {
    idleTitle: 'Toujours là ?',
    idleBody: 'Vous êtes inactif depuis un moment. Pour votre sécurité, nous allons vous déconnecter automatiquement.',
    idleStay: 'Rester connecté',
    idleSignedOut: 'Vous avez été déconnecté après {minutes} minutes d’inactivité. Veuillez vous reconnecter.',
  },
  // Browser form drafts (owner-stamped, 7 days, typed values only — app-kit
  // utils/formDraftStorage.ts). Owned by app-kit's DraftBanner and by the
  // sign-out warning every module chrome shows, so the wording lives here instead
  // of drifting across five app catalogs.
  formDrafts: {
    bannerTitle: 'Brouillon non enregistré',
    bannerSavedAt: 'Enregistré sur cet appareil : {when}',
    bannerRecordChanged: 'L’enregistrement a changé depuis ce brouillon. Restaurer ne remet que les champs que vous avez modifiés.',
    restore: 'Restaurer',
    discard: 'Supprimer',
    closeTitle: 'Abandonner la saisie dans « {form} » ?',
    closeBody: 'Les données non enregistrées seront perdues.',
    closeConfirm: 'Abandonner',
    closeCancel: 'Continuer la modification',
    recordChangedTitle: 'Modifié par quelqu’un d’autre',
    reload: 'Recharger',
    forms: {
      'apprentice': {
        planStation: 'Étape du plan de formation',
        skillCatalogue: 'Catalogue de compétences',
        trainingData: 'Données de la formation',
      },
      'ats': {
        workflowEditor: 'Éditeur de workflow',
      },
      'backoffice': {
        applicationForm: 'Candidature',
        createApplication: 'Nouvelle candidature',
        customField: 'Champ personnalisé',
        customFields: 'Champs personnalisés',
        emailSettings: 'Paramètres de messagerie',
        jobAd: 'Offre d\'emploi',
        jobAdTemplate: 'Modèle d\'offre d\'emploi',
        jobEdit: 'Poste',
        portalSettings: 'Paramètres du portail carrière',
        ravenBatchPublish: 'Publication groupée d\'offres',
        ravenPublish: 'Publication d\'offre',
        role: 'Rôle',
        suggestion: 'Suggestion',
        supportTicket: 'Ticket d\'assistance',
        supportTicketReply: 'Réponse au ticket d\'assistance',
        talentEdit: 'Profil de talent',
        workflowAction: 'Action de workflow',
        workflowCondition: 'Condition de workflow',
        workflowGuard: 'Garde de workflow',
        workflowState: 'État de workflow',
        workflowTransition: 'Transition de workflow',
      },
      'people': {
        bankAccount: 'Compte bancaire',
        companyProfile: 'Profil de l\'entreprise',
        employmentContract: 'Contrat de travail',
        myProfile: 'Mon profil',
        onboardingTemplate: "Modèle d'onboarding",
        oneTimePayment: 'Paiement unique',
        orgUnit: 'Unité organisationnelle',
        person: 'Personne',
        taxProfile: 'Profil fiscal',
        wageAssignment: 'Cession de salaire',
      },
      'system-admin': {
        fileQuota: 'Quota de fichiers',
        skillDetail: 'Détail de la compétence',
        suggestionNotes: 'Notes sur la suggestion',
      },
      'time': {
        blueprint: 'Modèle de temps de travail',
        leaveRequest: 'Demande de congé',
        leaveType: "Type d'absence",
        orgGroup: 'Groupe organisationnel',
        project: 'Projet',
        role: 'Rôle',
        userProfile: 'Profil utilisateur',
        weekGrid: 'Grille de semaine',
        workTimeModel: 'Modèle de temps de travail',
      },
      'user': {
        ssoSettings: 'Paramètres SSO',
      },
      'workspace': {
        billingProfile: 'Profil de facturation',
        wizardGeneral: 'Assistant de configuration',
      },
    },
  },
  // Suite-wide legal footer (issue 221): the § 5 DDG imprint and the privacy
  // notice of the Lumi entity live once on the marketing site, and every app
  // links to them through the shared LegalLinksFooter. The wording is
  // byte-identical everywhere, so it belongs to app-kit rather than to any app.
  legal: {
    imprint: 'Mentions légales',
    privacy: 'Confidentialité',
    terms: 'CGU',
    label: 'Informations légales',
    employeeNotice: 'Confidentialité chez {company}',
  },
  dataImport: {
    title: 'Import de données',
    intro: 'Importez des données existantes d\'un ancien système : téléversez un fichier, vérifiez la correspondance des champs, examinez l\'essai, puis validez.',
    backToList: 'Retour à l\'aperçu',
    sourceSystem: 'Système source',
    cancelled: 'Cet import a été annulé.',
    steps: {
      upload: 'Téléversement',
      analysis: 'Analyse',
      mapping: 'Correspondance',
      dryRun: 'Essai',
      commit: 'Validation',
    },
    status: {
      uploaded: 'Téléversé',
      analyzing: 'Analyse en cours',
      mapping_ready: 'Vérifier la correspondance',
      dry_running: 'Essai en cours',
      dry_run_ready: 'Essai terminé',
      committing: 'Validation en cours',
      completed: 'Terminé',
      failed: 'Échoué',
      cancelled: 'Annulé',
    },
    formats: {
      csv: 'CSV',
      xlsx: 'Excel',
      json: 'JSON',
      sql_dump: 'Dump SQL',
      hropen: 'HR Open JSON',
    },
    transforms: {
      none: 'Direct',
      date: 'Date',
      number: 'Nombre',
      boolean: 'Oui/Non',
      enum_map: 'Correspondance de valeurs',
      split_name: 'Scinder le nom',
      concat: 'Concaténer',
      const: 'Constante',
      skip: 'Ignorer',
    },
    upload: {
      sourceSystem: 'Nom du système source',
      sourceSystemHint: 'Conservé comme référence : réimporter le même fichier met à jour les enregistrements au lieu de les dupliquer.',
      sourceSystemPlaceholder: 'p. ex. ancien_sirh',
      sourceSystemFirst: 'Veuillez d\'abord nommer le système source.',
      dropHint: 'Déposez un fichier ici ou parcourez',
      formats: 'CSV, Excel (XLSX), JSON ou dump SQL — max. 50 Mo',
      browse: 'Choisir un fichier',
      uploading: 'Téléversement …',
    },
    running: {
      uploaded: 'Démarrage de l\'analyse …',
      analyzing: 'Analyse du fichier …',
      dry_running: 'Essai en cours …',
      committing: 'Écriture des données …',
      hint: 'Les gros fichiers peuvent prendre quelques minutes. Cette page se met à jour automatiquement.',
    },
    failed: {
      title: 'Échec de l\'import',
    },
    mapping: {
      hint: 'Vérifiez la correspondance proposée : une cible par table, un champ par colonne. Les lignes surlignées sont des propositions incertaines.',
      targetEntity: 'Cible',
      skipTable: 'Ne pas importer',
      skippedTable: 'Cette table ne sera pas importée.',
      ignoreColumn: 'Ignorer',
      sourceColumn: 'Colonne',
      sample: 'Exemples',
      targetField: 'Champ cible',
      transform: 'Transformation',
      preview: 'Aperçu',
      rowCount: '{count} lignes',
      patternHint: 'Motif de date, p. ex. DD.MM.YYYY',
      multiTargetHint: 'Cible {index} sur {total} — le même fichier alimente plusieurs cibles',
      valueMap: 'Associer les valeurs',
      valueMapHint: 'Associez les valeurs sources aux valeurs autorisées dans le système. Les valeurs non associées produisent une erreur par ligne lors de l’essai. Basé sur jusqu’à 20 valeurs d’exemple distinctes de la colonne.',
      valueMapUnmapped: '— non associée —',
      addColumnRow: 'Réassocier une colonne',
      customFieldBadge: 'Champ personnalisé',
      createCustomField: 'Créer un champ personnalisé…',
      confirm: 'Confirmer et lancer l\'essai',
    },
    report: {
      dryRunHint: 'Essai — rien n\'a encore été écrit. Vérifiez les totaux et les erreurs avant de valider.',
      completedHint: 'Import terminé. Les données ont été écrites.',
      created: 'Créés',
      updated: 'Mis à jour',
      skipped: 'Ignorés',
      errors: 'Erreurs',
      errorList: '{count} erreurs',
      downloadErrors: 'Télécharger toutes les erreurs',
      row: 'Ligne',
      errorMessage: 'Message',
      backToMapping: 'Retour à la correspondance',
      commit: 'Valider les données',
      commitConfirmTitle: 'Valider les données ?',
      commitConfirmBody: 'L\'import va écrire dans ce module. Les nouveaux enregistrements sont créés, les existants mis à jour. Annulation automatique impossible.',
      commitStarted: 'Validation lancée – les données sont en cours d’écriture.',
    },
    // An import report's error row, worded from the facts the module sent (rowErrorText.ts).
    rowErrors: {
      required: '{field} est vide, alors que chaque ligne doit en avoir une valeur.',
      unknownField: '{field} ne peut pas être importé ici.',
      invalidEnum: '« {value} » n’est pas une valeur valide pour {field}. Valeurs valides : {allowed}. Associez-la dans l’étape de correspondance, sous « Associer les valeurs ».',
      unresolved: {
        person: 'Aucune personne trouvée dont {keys} est « {value} ».',
        supervisor: 'Aucun responsable hiérarchique trouvé dont {keys} est « {value} ».',
        functionalSupervisor: 'Aucun responsable fonctionnel trouvé dont {keys} est « {value} ».',
        orgUnit: 'Aucune unité org. trouvée dont {keys} est « {value} ».',
        parentOrgUnit: 'Aucune unité org. parente trouvée dont {keys} est « {value} ».',
      },
      supervisorRequired: 'Aucun responsable hiérarchique trouvé dont {keys} est « {value} », et cette personne n’en a pas encore. Chaque personne active en a besoin : importez d’abord le responsable hiérarchique ou indiquez-en un qui existe déjà.',
      unknownEntity: 'Ce type de données ne peut pas être importé ici.',
      emailLinked: 'Cette personne se connecte à lumi avec cette adresse e-mail ; l’import ne peut donc pas la modifier. Indiquez son adresse actuelle dans le fichier ou n’importez pas la colonne e-mail.',
      supervisorMissing: 'Chaque personne active a besoin d’un responsable hiérarchique, et cette personne n’en a pas. Indiquez-en un dans le fichier ou créez d’abord le responsable.',
      transformFailed: '« {value} » dans la colonne {field} n’a pas pu être converti. Vérifiez son format sous « Transformation » dans l’étape de correspondance.',
      transformFailedNoValue: 'Une valeur de la colonne {field} n’a pas pu être convertie. Vérifiez son format sous « Transformation » dans l’étape de correspondance.',
      unknown: 'Cette ligne n’a pas été importée. Les détails figurent dans le fichier d’erreurs.',
      ambiguous: {
        collision: '{ref} : « {value} » correspond à deux enregistrements différents — à l’un comme ID externe, à un autre comme {other}. L’import ne devine pas : rendez la référence univoque dans le fichier.',
        otherSystem: '{ref} : « {value} » n’est pas un ID externe de ce système source mais de « {system} » — et correspond aussi à un enregistrement comme {other}. L’import ne devine pas : importez avec le système source « {system} » s’il s’agit du même, ou rendez la référence univoque.',
        holderHasExternalId: '{ref} : « {value} » ne correspond que comme {other} — et cet enregistrement a déjà l’ID externe « {otherId} » dans ce système source. L’import ne devine pas : utilisez « {otherId} » s’il s’agit de lui.',
      },
      refs: {
        person: 'Personne',
        supervisor: 'Responsable hiérarchique',
        functionalSupervisor: 'Responsable fonctionnel',
        orgUnit: 'Unité org.',
        parentOrgUnit: 'Unité org. parente',
      },
      supervisorInactive: {
        supervisor: 'Le responsable hiérarchique indiqué n’est plus actif et ne peut donc encadrer personne.',
        functional: 'Le responsable fonctionnel indiqué n’est plus actif et ne peut donc encadrer personne.',
      },
      supervisorUnconfirmed: {
        supervisor: 'Le responsable hiérarchique indiqué n’a pas encore été confirmé par les RH et ne peut donc encadrer personne. Confirmez-le d’abord dans People.',
        functional: 'Le responsable fonctionnel indiqué n’a pas encore été confirmé par les RH et ne peut donc encadrer personne. Confirmez-le d’abord dans People.',
      },
      datesInverted: 'La date sous {end} est antérieure à celle sous {start}.',
      agreementCodeInvalid: '{field} n’accepte que des lettres, des chiffres, « - », « _ » et « . », 60 caractères au plus et sans espace.',
      statusTransition: 'Un contrat ne peut pas passer de « {from} » à « {to} ».',
      reportingCycle: 'Cette affectation fermerait la ligne hiérarchique en boucle.',
      ambiguousOrgCode: 'Plusieurs unités org. de types différents ont le code « {value} ». Désignez la bonne par son ID externe.',
      keys: {
        externalId: 'l’ID externe',
        employeeNumber: 'le matricule',
        code: 'le code',
      },
    },
    list: {
      title: 'Imports précédents',
      file: 'Fichier',
      system: 'Système source',
      status: 'Statut',
      created: 'Créé',
      empty: 'Aucun import pour l\'instant.',
      open: 'Ouvrir',
      delete: 'Supprimer',
      deleteConfirmTitle: 'Supprimer l’import ?',
      deleteConfirmBody: '« {file} » et tous ses fichiers d’import seront supprimés. Les données déjà reprises sont conservées.',
      deleted: 'Import « {file} » supprimé.',
    },
  },
  dataExport: {
    title: 'Export HR Open',
    intro: 'Exporte les données de ce module au format HR Open 4.5 (HR-JSON) — validé par rapport au standard.',
    create: 'Créer un export',
    creating: 'Création …',
    download: 'Télécharger',
    password: {
      title: 'Mot de passe du ZIP — visible maintenant seulement',
      hint: 'L’export est créé comme ZIP protégé par mot de passe (AES-256) car il contient des données personnelles. Copiez le mot de passe maintenant — il ne sera plus affiché. Ouvrir avec p. ex. 7-Zip, WinZip ou Keka.',
      copy: 'Copier le mot de passe',
      copied: 'Copié',
    },
    empty: 'Aucun export pour l’instant.',
    columns: {
      standard: 'Standard',
      status: 'Statut',
      items: 'Enregistrements',
      created: 'Créé',
    },
    status: {
      queued: 'En file d’attente',
      generating: 'Génération',
      completed: 'Terminé',
      failed: 'Échoué',
    },
  },
  // The demo's module picker (ADR 0083): the fork offers it on entry, the bar's
  // reset confirmation again. A locked module is booked (or core) and always in.
  // RoleNameTranslations.vue (ADR 0086): a custom role's names in other
  // languages, or the notice a system role gets instead.
  roleNames: {
    translations: 'Traductions',
    translationsHint: 'Le nom dans d’autres langues. Les champs vides affichent le nom ci-dessus.',
    systemHint: 'Rôle système : lumi le nomme dans chaque langue. Son nom et sa description ne peuvent pas être modifiés, ses autorisations oui.',
  },
  demoModules: {
    legend: 'Modules de la démo',
    booked: 'Souscrit — toujours inclus',
  },
  demoStage: {
    label: 'Démo',
    viewingAs: 'Vue en tant que',
    personaPlaceholder: 'Choisir un rôle',
    persona: {
      team_lead: 'Responsable d’équipe',
      employee: 'Employé',
      hr_admin: 'Admin RH',
      recruiter: 'Recruteur',
      ats_admin: 'Administrateur ATS',
      council_member: 'Membre du comité d’entreprise',
      apprentice: 'Apprenti',
      trainer: 'Formateur',
    },
    personaDoes: {
      team_lead: 'Décide des demandes d’absence et de correction, et évalue les candidatures.',
      employee: 'Enregistre des journées de travail, demande des absences et fait corriger des saisies.',
      hr_admin: 'Crée des personnes, des projets et des offres d’emploi.',
      recruiter: 'Fait avancer les candidatures en présélection et planifie des entretiens.',
      ats_admin: 'Décide des absences, évalue les candidatures et crée des offres d’emploi.',
      council_member: 'Donne le vote du comité d’entreprise sur les offres d’emploi et les propositions.',
      apprentice: 'Coche les étapes du plan de formation et enregistre des journées de travail.',
      trainer: 'Relit les rapports des apprentis et planifie leurs examens.',
    },
    picker: {
      title: 'Depuis quel point de vue voulez-vous voir la démo ?',
      subtitle: '{count} collègues chez {company}. Chaque rôle a ses propres tâches — vos coches sont conservées par rôle.',
      taskCount: '{total} tâche | {total} tâches',
    },
    intro: {
      lead: 'est fictive. Les personnes qui y figurent sont également fictives. Tout ce qui se trouve sous la barre appartient à la démo — vous y prenez différents rôles. Votre compte réel n’est pas affecté.',
      bridgeBefore: 'Vous pouvez terminer la démo à tout moment. Toutes les données ci-dessous sont alors supprimées et vous pouvez configurer ',
      bridgeAfter: ' pour votre organisation.',
      close: 'Fermer',
    },
    reset: 'Réinitialiser la démo',
    guestMarker: 'Invité',
    guestWelcome: {
      invitedBy: 'Un collègue de {workspace} vous a invité à cette démo.',
      invitedAnon: 'Un collègue vous a invité à cette démo.',
      body: '{company} est fictive et partagée avec toutes les autres personnes de cette démo. D’autres ont peut-être déjà essayé des choses, elle peut donc sembler déjà entamée. « {reset} » donne à tout le monde un nouveau départ. Votre accès prend fin avec la démo. Les personnes qui y figurent sont également fictives.',
    },
    cancel: 'Annuler',
    rebuildFailed: 'La démo n’a pas pu être reconstruite. Veuillez réessayer.',
    resetConfirm: {
      title: 'Réinitialiser la démo ?',
      body: 'Tout ce que {company} contient actuellement est supprimé — y compris ce que vous ou vos collègues avez saisi, et la progression de chacun dans les parcours — et la démo est reconstruite de zéro. Tout le monde dans la démo repart de zéro ; les accès ne changent pas.',
      cta: 'Réinitialiser la démo',
    },
    // The demo bar's "Invite a colleague" dialog (issue 669).
    guests: {
      entry: 'Inviter un·e collègue',
      title: 'Inviter un·e collègue',
      subtitle: 'Les collègues que vous invitez voient cette démo telle qu’elle est et peuvent l’essayer eux-mêmes.',
      close: 'Fermer',
      loading: 'Chargement…',
      retry: 'Réessayer',
      emailLabel: 'Adresse e-mail professionnelle',
      emailPlaceholder: "nom{'@'}entreprise.fr",
      send: 'Envoyer l’invitation',
      sendAgain: 'Renvoyer',
      slotsLeft: '{count} place libre | {count} places libres',
      exhausted: 'Les {limit} places sont prises. Révoquez une invitation ci-dessous pour inviter quelqu’un d’autre.',
      invalid: 'Saisissez une adresse e-mail valide.',
      listTitle: 'Dans cette démo, en dehors de vous',
      used: '{used} sur {limit} utilisées',
      empty: 'Personne n’a encore été invité.',
      state: {
        invited: 'Invité',
        joined: 'A rejoint',
      },
      revoke: 'Révoquer',
      revoking: 'Révocation…',
      revokeFor: 'Révoquer l’accès de {email}',
      about: {
        title: 'Ce qu’est un invité',
        sees: 'Un invité voit cette démo exactement dans son état actuel — y compris tout ce que vous avez déjà essayé. « {reset} » dans la barre offre à tout le monde un nouveau départ.',
        resets: 'Un invité peut lui aussi réinitialiser la démo — pour tous ceux qui y participent.',
        limits: 'Un invité ne peut jamais terminer la démo ni toucher à votre véritable espace de travail.',
        ends: 'Les invités sont retirés dès que la démo prend fin.',
      },
      feedback: {
        sent: 'Invitation envoyée à {email}.',
        resent: 'Invitation renvoyée à {email}.',
        undelivered: 'L’e-mail à {email} n’a pas pu être remis. {email} figure dans la liste et occupe une place — renvoyez l’invitation pour réessayer.',
        revoked: 'L’accès de {email} a été révoqué. La place est de nouveau libre.',
        alreadyMember: '{email} a déjà accès à cet espace de travail.',
        limit: 'Toutes les places sont prises. Révoquez une invitation pour inviter quelqu’un d’autre.',
        rateLimited: 'Trop d’invitations aujourd’hui. Veuillez réessayer plus tard.',
        notLive: 'Les invitations ne fonctionnent que tant que la démo est active. Elle est en cours de reconstruction, ou la configuration a commencé — réessayez quand la démo sera de retour.',
        operator: 'Vous êtes connecté en tant qu’opérateur système. Les opérateurs ne peuvent pas inviter de collègues dans la démo d’un client.',
        operatorNotMember: '{email} correspond à un compte d’opérateur lumi, qui ne peut pas rejoindre la démo d’un client. Veuillez inviter une autre adresse.',
        notAPerson: '{email} correspond à un compte qui n’est pas une personne, par exemple un compte de service. Veuillez inviter l’adresse e-mail professionnelle d’un collègue.',
        forbidden: 'Seuls le propriétaire de l’espace de travail ou un administrateur de la suite peuvent inviter des collègues.',
        noticeIncomplete: 'Les invitations sont suspendues tant que les mentions pour les salariés ne sont pas complètement remplies dans Mentions légales.',
        accountClosed: 'Ce compte a été fermé et ne peut pas être invité.',
        unavailable: 'Les invitations ne peuvent pas être comptées pour le moment. Veuillez réessayer dans un instant.',
        revokeFailed: 'L’accès de {email} n’a pas pu être révoqué. Veuillez réessayer.',
        generic: 'Une erreur s’est produite. Veuillez réessayer.',
      },
    },
    leave: 'Terminer la démo',
    continueSetup: 'Poursuivre la configuration',
    menu: 'Actions de la démo',
    signOut: 'Se déconnecter',
    logoutHint: 'Pendant la démo, déconnectez-vous depuis la porte ou le menu de la barre de démo.',
    journey: {
      title: 'Le parcours de {name}',
      count: '{done} sur {total} terminées',
      refresh: 'Actualiser le parcours',
      unknown: 'Certaines vérifications sont injoignables – le dernier état connu est affiché.',
      yay: 'C’était tout le parcours de {name} – bien joué.',
      bridgeAdmin: 'Vous avez suivi tous les parcours. Quand vous serez prêt, terminez la démo et configurez votre propre espace de travail.',
      bridgeUser: 'Vous avez suivi tous les parcours. Un administrateur peut terminer la démo et configurer votre espace de travail.',
      blockedReset: 'Une réinitialisation le rétablit :',
      blocked: {
        gone: 'Ce dont cette tâche a besoin n’existe plus.',
      },
      next: 'À suivre',
      nextCta: 'Ouvrir dans {module}',
      footer: 'La démo coche ce que vous faites.',
    },
  },
  // The shared notifications popover (NotificationsPopover.vue). Its own namespace: the
  // apps' `notifications.*` keys (inbox page, preferences) are theirs and stay put.
  notificationsPopover: {
    title: 'Notifications',
    empty: 'Vous êtes à jour.',
    markAllRead: 'Tout marquer comme lu',
    markRead: 'Marquer comme lu',
    markUnread: 'Marquer comme non lu',
    loading: 'Chargement…',
    openTarget: 'Ouvrir l\'élément lié',
    goToAll: 'Voir les notifications',
  },
  // The shared place search (PlacePicker.vue). `noMatchAdd` is the wording for hosts whose
  // typed text IS the name (Enter adds it as typed); `noMatch` for hosts that keep it beside the field.
  placePicker: {
    placeholder: 'Rechercher une ville ou une commune …',
    keptHint: 'Enregistré tel que vous l’avez saisi — sans localité liée.',
    searching: 'Recherche en cours …',
    typeMore: 'Saisissez au moins {count} caractères',
    noMatch: 'Aucune correspondance — votre saisie est conservée',
    error: 'Échec de la recherche',
    rateLimited: 'Trop de recherches — nouvelle tentative dans un instant',
    resultsAnnouncement: 'Aucun résultat | 1 résultat | {count} résultats',
    clear: 'Supprimer la localité',
    noMatchAdd: 'Aucune ville trouvée — Entrée ajoute le nom tel quel',
  },
  // The suite's five app names and their one-line launcher descriptions, in this
  // language. THE one copy: component-lib's registry carries no displayed string, and
  // every app merges this underneath its own messages (ADR 0026 section 7).
  lumiModules: {
    suite: {
      name: 'Accueil',
      description: 'Votre vue d\'ensemble de l\'espace de travail',
    },
    ats: {
      name: 'Recrutement',
      description: 'Postes, candidatures et processus de recrutement',
    },
    time: {
      name: 'Temps',
      description: 'Saisie du temps, comptes de temps de travail et validations',
    },
    people: {
      name: 'Personnel',
      description: 'Dossiers du personnel, services et sites',
    },
    apprentice: {
      name: 'Apprentis',
      description: 'Cahiers de formation numériques et plans de formation',
    },
  },
};
